module.exports = __webpack_public_path__ + "static/media/july_2025_3.f2be49b9.webp";